var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[
    'message',
    {
      info: _vm.type === 'info',
      warning: _vm.type === 'warning',
      success: _vm.type === 'success',
      error: _vm.type === 'error'
    }
  ]},[_c('app-close-icon',{staticClass:"close-icon",on:{"click":function($event){return _vm.$emit('close')}}}),_c('div',{staticClass:"header"},[_vm._t("header")],2),_c('div',{staticStyle:{"margin-top":"0.5rem"}},[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }